/// <reference path="../../../../typings/index.d.ts" />
module Meevo.Plugins.Resources {
    angular.module("meevo.plugins.resources", []);
}